export default __webpack_public_path__ + "static/media/ds-resolv-algo-js.e8eac9e0.png";